import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './InformationalHeroCards.css';
import React from 'react';
import { get, getPageThemeColors, getColorByTheme, canUseDOM } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import RouterLink from '../atoms/RouterLink';
export var InformationalHeroCards = function InformationalHeroCards(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    _ref$bannerSlideTitle = _ref.bannerSlideTitle,
    bannerSlideTitle = _ref$bannerSlideTitle === void 0 ? '' : _ref$bannerSlideTitle;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var links = get(fields, 'data.item.cards.targetItems') || [];
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--m113-InformationalHeroCards-background-color': BackgroundColorHex,
    '--m113-InformationalHeroCards-background-active-color': ActiveColorHex,
    '--m113-InformationalHeroCards-color': ColorHex
  } : {
    '--m113-InformationalHeroCards-background-color': selectedPrimaryColor,
    '--m113-InformationalHeroCards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-InformationalHeroCards-color': getColorByTheme(selectedPrimaryColor)
  };
  if (!get(fields, 'data.item')) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('InformationalHeroCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [InformationalHeroCards component is empty: please provide data source]");
    }
    return null;
  }
  var renderLinks = function renderLinks() {
    if (links && links.length) {
      return links.map(function (el, index) {
        var id = get(el, 'id');
        var title = get(el, 'title.jss.value');
        var desc = get(el, 'shortDescription.jss.value');
        var icon = get(el, 'svgIcon.targetItem.svg.jss.value');
        var linkHref = get(el, 'link.jss.value.href');
        return /*#__PURE__*/React.createElement(RouterLink, {
          className: "m113-card",
          href: linkHref,
          key: id,
          onClick: function onClick() {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['cardsClickAnalytics'], params), [title, bannerSlideTitle]);
          },
          dataCy: "multifunctional-card-link",
          linktype: "external",
          openInSameTab: true
        }, icon ? /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: icon
          },
          className: "icon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
          className: "m113-card__title"
        }, title), /*#__PURE__*/React.createElement("p", {
          className: "m113-card__text"
        }, desc));
      });
    }
    return /*#__PURE__*/React.createElement("div", null);
  };
  var renderCarousel = function renderCarousel() {
    return /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
      var renderCarousel = _ref2.renderCarousel,
        renderPreviousButton = _ref2.renderPreviousButton,
        renderNextButton = _ref2.renderNextButton,
        renderDots = _ref2.renderDots,
        state = _ref2.state;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: ""
      }, renderCarousel(renderLinks(), {
        responsive: {
          desktopLarge: {
            breakpoint: {
              max: 10000,
              min: 1700
            },
            items: 5,
            partialVisibilityGutter: 0
          },
          desktop: {
            breakpoint: {
              max: 1699,
              min: 1200
            },
            items: 4,
            partialVisibilityGutter: 0
          },
          tabletLarge: {
            breakpoint: {
              max: 1199,
              min: 768
            },
            items: 3,
            partialVisibilityGutter: 20
          },
          tablet: {
            breakpoint: {
              max: 767,
              min: 480
            },
            items: 2,
            partialVisibilityGutter: 20
          },
          mobile: {
            breakpoint: {
              max: 479,
              min: 0
            },
            items: 1,
            partialVisibilityGutter: 150
          }
        },
        containerClass: '',
        partialVisible: true
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "m113-mult-card",
    style: variables
  }, renderCarousel()));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cvupt7m";
var ltrStyles = "l4kkmk9";
var rtlStyles = "r1m1i4y2";
export default InformationalHeroCards;